import Vue from "vue";
import VueRouter from "vue-router";
import createManagementRouter from "@shared/createManagementRouter.cjs";

const requireAuth = () =>
  createManagementRouter.createAuthGuard({
    storage: localStorage,
    redirectPath: "/",
  });

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
  },
  {
    path: "/",
    component: () => import("../components/Container.vue"),
    beforeEnter: requireAuth(),
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("../views/Dashboard.vue"),
      },
      {
        path: "schedules",
        name: "Schedules",
        component: () => import("../views/Schedules.vue"),
      },
      {
        path: "booking-settings",
        name: "BookingSettings",
        component: () => import("../views/BookingSettings.vue"),
      },
      {
        path: "comparison-estimate-settings",
        name: "ComparisonEstimateSettings",
        component: () => import("../views/ComparisonEstimateSettings.vue"),
      },
      {
        path: "estimates",
        name: "Estimates",
        component: () => import("../views/estimates/Index.vue"),
      },
      {
        path: "estimates/:id",
        name: "EstimateDetail",
        component: () => import("../views/estimates/Detail.vue"),
      },
      {
        path: "products",
        name: "Products",
        component: () => import("../views/Products.vue"),
      },
      {
        path: "products/create",
        name: "ProductCreate",
        component: () => import("../views/ProductForm.vue"),
      },
      {
        path: "products/:id",
        name: "ProductEdit",
        component: () => import("../views/ProductForm.vue"),
      },
      {
        path: "reviews",
        name: "Reviews",
        component: () => import("../views/Reviews.vue"),
      },
      {
        path: "business-info",
        name: "BusinessInfo",
        component: () => import("../views/BusinessInfo.vue"),
      },
      {
        path: "notifications",
        name: "Notifications",
        component: () => import("../views/Notifications.vue"),
      },
      {
        path: "chats",
        name: "Chats",
        component: () => import("../views/Chats.vue"),
      },
      {
        path: "notices",
        name: "Notices",
        component: () => import("../views/Notices.vue"),
      },
      {
        path: "point-management",
        name: "PointManagement",
        component: () => import("../views/PointManagement.vue"),
      },
    ],
  },
];

const router = createManagementRouter({
  Framework: Vue,
  RouterLibrary: VueRouter,
  base: process.env.BASE_URL,
  routes,
});

export default router;
